import Vue from 'vue'
import App from './App.vue'
import router from './router';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import './plugins/fontawesome';



Vue.config.productionTip = false

function loadYouTubeAPI() {
  return new Promise((resolve) => {
    if (window.YT) return resolve(true)

    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    window.onYouTubeIframeAPIReady = () => resolve(true)

    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  })
}

async function initializeApp() {
  try {
    const youtubeLoaded = await Promise.race([
      loadYouTubeAPI(),
      new Promise(resolve => setTimeout(() => resolve(false), 3000))
    ])

    if (!youtubeLoaded) {
      console.warn('YouTube API no cargó a tiempo - continuando sin ella')
    }

    // 👇 Aquí agregamos AOS.init()
    new Vue({
      router,
      render: h => h(App),
      mounted() {
        if (window.AOS) {
          window.AOS.init({
            duration: 800,
            easing: 'ease-in-out',
            once: false
          });
        } else {
          console.warn('AOS no está disponible en window');
        }
      }
    }).$mount('#app')

  } catch (error) {
    console.error('Error al inicializar la aplicación:', error)
  }
}

if (document.readyState === 'complete') {
  initializeApp()
} else {
  document.addEventListener('DOMContentLoaded', initializeApp)
}
